import { profileSchema } from "./profile.js";
import * as z$1 from "zod/v4";
//#region src/schemas/protocol/hello.ts
const helloCapabilitiesSchema = z$1.object({
	agentReplyPlacement: z$1.boolean().optional(),
	liveSignalHistory: z$1.boolean().optional(),
	spaceMessageAddressing: z$1.boolean().optional(),
	spaceImageGeometry: z$1.boolean().optional()
});
const helloSchema = z$1.object({
	type: z$1.literal("hello"),
	profile: profileSchema,
	capabilities: helloCapabilitiesSchema.optional()
});
const helloAckSchema = z$1.object({
	type: z$1.literal("system.hello.ack"),
	profile: profileSchema
});
//#endregion
export { helloAckSchema, helloCapabilitiesSchema, helloSchema };

//# sourceMappingURL=hello.js.map